var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatientAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13C1 11.5272 3.08934 10.3333 5.66667 10.3333C8.244 10.3333 10.3333 11.5272 10.3333 13M11.6667 10.3333V6.33333M9.66667 8.33333L13.6667 8.33333M9 4.33333C9 6.17428 7.50762 7.66667 5.66667 7.66667C3.82572 7.66667 2.33333 6.17428 2.33333 4.33333C2.33333 2.49238 3.82572 1 5.66667 1C7.50762 1 9 2.49238 9 4.33333Z",
    stroke: "#8193A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientAdd);
export default __webpack_public_path__ + "static/media/patientAdd.2802e59470e0092654bd05da472dd091.svg";
export { ForwardRef as ReactComponent };